module.exports = __webpack_public_path__ + "img/marker-point-indigo.bb28dbf0.png";